import React from 'react'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from '../../../../PageWrapper'
import BreadcrumbNav from '../../../../components/Breadcrumbs'
import { Stack } from '@sureco/design-system'
import { Link, routerShape } from 'react-router'
import { HRIS_PATH } from '../../constants'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import {
  navAbilitiesForHref,
  PAYROLL_API_ACTIVITY_NAV_HREF,
} from 'enrollment-platform/rbac/nav-ability-map'
import { usePermission } from 'enrollment-platform/rbac/usePermission'

const { Content } = Layout

function Landing({
  router,
  children,
}: {
  router: routerShape
  children?: React.ReactNode
}) {
  const payrollAbility = navAbilitiesForHref(PAYROLL_API_ACTIVITY_NAV_HREF)?.[0]
  const { allowed: hasPayrollAbility } = usePermission(
    payrollAbility?.action ?? RbacActions.Manage,
    payrollAbility?.subject ?? RbacSubjects.UsRestrictedData
  )
  const showPayrollApiActivity = !payrollAbility || hasPayrollAbility

  // If there are child routes being rendered, show them
  if (children) {
    return children
  }

  return (
    <PageWrapper>
      <Page
        title="API Visibility"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Home', path: `/` },
              { title: 'HRIS', path: HRIS_PATH },
              { title: 'API Visibility' },
            ]}
          />
        }
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content style={{}}>API Activity</Content>
          <Stack direction="col" space={20} margin="20px 0">
            <Link to={`${router.location.pathname}/census-api-activity`}>
              <div style={{ marginRight: '8px' }} />
              Census API Activity
            </Link>
            {showPayrollApiActivity ? (
              <Link to={`${router.location.pathname}/payroll-api-activity`}>
                <div style={{ marginRight: '8px' }} />
                Payroll API Activity
              </Link>
            ) : null}
            <Link to={`${router.location.pathname}/cmv2-api-visibility`}>
              <div style={{ marginRight: '8px' }} />
              CMv2 API Visibility
            </Link>
          </Stack>
        </Layout>
      </Page>
    </PageWrapper>
  )
}

export default Landing
